import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'AI Millionaire Tactics';
render(<App data-id="element-303" />, document.getElementById('root'));